import { Timeframe } from '@ankr.com/chains-list';
import { useMemo } from 'react';

import { FULL_TIMEFRAME_LIST } from 'modules/chains/constants';
import { Tab, useTabs } from 'modules/common/hooks/useTabs';
import { TabSize } from 'modules/common/components/SecondaryTab';

import { TimeframeTabs } from '../TimeframeTabs';
import { useTimeframe } from '../TimeframeProvider';
import { useTimeframesStyles } from './useTimeframesStyles';

interface TimeframesProps {
  className?: string;
  tabSize?: TabSize;
}

export const Timeframes = ({
  className,
  tabSize = TabSize.Smallest,
}: TimeframesProps) => {
  const { classes, cx } = useTimeframesStyles();

  const { setTimeframe, timeframe } = useTimeframe();

  const tabs = useMemo(
    () =>
      FULL_TIMEFRAME_LIST.map<Tab<Timeframe>>(id => ({
        id,
        onSelect: () => setTimeframe(id),
      })),
    [setTimeframe],
  );

  const [timeframeTabs] = useTabs({
    initialTabID: timeframe,
    tabs,
  });

  return (
    <TimeframeTabs
      className={cx(classes.root, className)}
      size={tabSize}
      tabClassName={classes.tab}
      tabs={timeframeTabs}
      timeframe={timeframe}
    />
  );
};
